import styled from '@emotion/styled';
import { TextareaAutosize } from '@material-ui/core';

const StyledTextArea = styled(TextareaAutosize)`
  padding: 10px;
  padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : '0px')};
  border-radius: 0px;
  border: none;
  border-bottom: 1px dashed ${(props) => props.theme.colors.text.g3};
  &:hover {
    border-bottom-style: solid;
  }
  &:focus, &:focus-within, &: active {
    outline: unset;
    border-bottom: 1px solid ${(props) => props.theme.colors.primary['1565BC']};
  }
  color: ${(props) => props.theme.colors.text.g1};
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  resize: none;
`;

export const InputMaterialUITextArea = ({ ...textAreaProps }) => <StyledTextArea {...textAreaProps} />;
